import React from 'react';
import { lazyForPaint } from 'react-loosely-lazy';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async';
import { componentWithFF } from '@atlassian/jira-feature-flagging-utils';
import { globalLayout } from '@atlassian/jira-global-layout';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common';
import { createEntry } from '@atlassian/jira-route-entry';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation';
import { ErrorPagesNotFound } from '@atlassian/jira-router-routes-common';
import { jiraConfiguratorRoute } from '@atlassian/jira-router-routes-jira-configurator-routes';
import type JiraConfiguratorType from '@atlassian/jira-spa-apps-jira-configurator';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page';

const LazyJiraConfiguratorPage = lazyForPaint<typeof JiraConfiguratorType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-configurator", jiraSpaEntry: "async-jira-configurator" */ '@atlassian/jira-spa-apps-jira-configurator'
		),
	),
);

export const JiraConfiguratorComponent = () => (
	<LazyPage
		Page={LazyJiraConfiguratorPage}
		pageId="async-jira-configurator"
		shouldShowSpinner={false}
	/>
);

export const jiraConfiguratorRouteEntry = createEntry(jiraConfiguratorRoute, {
	component: componentWithFF(
		'com.atlassian.rm.jpo.jsw-configurator-mvp_kd5ha',
		JiraConfiguratorComponent,
		ErrorPagesNotFound,
	),
	layout: globalLayout,
	navigation: {
		menuId: MENU_ID.PLANS,
	},
	resources: [...getNavigationResources()],
	forPaint: [LazyAtlassianNavigation, LazyJiraConfiguratorPage],
});
